var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post"},[_c('BlogNav'),_c('div',{staticClass:"post-ctx"},[_c('div',{staticClass:"md-body",domProps:{"innerHTML":_vm._s(_vm.md)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }